import { Key, Entity } from '@briebug/ngrx-auto-entity';

export interface HasDelta {
  delta: number;
}

export const compareDelta = (a: HasDelta, b: HasDelta) => a.delta - b.delta;

@Entity({
  comparers: {
    default: compareDelta,
  },
  modelName: 'EquipmentOptionType',
})
export class EquipmentOptionType {
  @Key id: number;
  name: string;
  delta: number;
}
